import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function HubspotIcon(props: IconProps) {
  const id = useId();

  return (
    <Icon viewBox="0 0 20 21" {...props}>
      <Box as="g" clipPath={`url(#hubspot-a-${id})`}>
        <Box
          as="path"
          fill="#FF7A59"
          d="M15.356 6.894V4.401a1.92 1.92 0 0 0 1.106-1.73v-.058c0-1.06-.86-1.92-1.92-1.92h-.057c-1.06 0-1.92.86-1.92 1.92v.058a1.92 1.92 0 0 0 1.107 1.73v2.493a5.436 5.436 0 0 0-2.585 1.139L4.25 2.706c.048-.176.074-.357.076-.538A2.163 2.163 0 1 0 2.16 4.326h.001a2.14 2.14 0 0 0 1.066-.29l6.734 5.24a5.456 5.456 0 0 0 .083 6.143l-2.048 2.05a1.749 1.749 0 0 0-.512-.084 1.777 1.777 0 1 0 1.778 1.778 1.778 1.778 0 0 0-.084-.512l2.027-2.027a5.464 5.464 0 1 0 4.152-9.73m-.84 8.2a2.803 2.803 0 1 1 0-5.603 2.804 2.804 0 0 1 .004 5.601"
        />
      </Box>
      <Box as="defs">
        <clipPath id={`hubspot-a-${id}`}>
          <Box as="path" fill="#fff" d="M0 0h20v20.938H0z" />
        </clipPath>
      </Box>
    </Icon>
  );
}
